import { useAuth } from "../contexts/AuthContext";

export function ManagerSelector() {
  const { me, managers, managerId, setManagerId, t } = useAuth();
  if (!me?.is_admin) return null;

  return (
    <div className="px-5 py-2 bg-slate-50 border-b border-slate-200 flex items-center gap-2 text-xs flex-shrink-0">
      <span className="text-slate-600 font-medium">{t("header_dept")}:</span>
      <select
        value={managerId}
        onChange={(e) => setManagerId(e.target.value)}
        className="bg-white text-slate-900 rounded px-2 py-1 text-xs flex-1 border border-slate-300"
      >
        <option value="__dept__">📊 {t("header_dept")} (admin)</option>
        {managers.map(m => (
          <option key={m.id} value={m.id}>{m.full_name}</option>
        ))}
      </select>
    </div>
  );
}
